export default __webpack_public_path__ + "static/media/contacts-svgrepo-com.31da0c5a.svg";